import clsx from 'clsx';
import React, { useCallback, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core';

import lodashDebounce from 'lodash-es/debounce';
import styles from './style';
import TextField from '../atomic/TextField';
import SearchIcon from '../../assets/icons/Search';
import InputAdornment from '../atomic/InputAdornment';

const SearchField = ({
  classes,
  bordered,
  className,
  placeholder,
  value,
  onChange,
  ...props
}) => {
  const [query, setQuery] = useState(null);

  const search = useCallback(
    lodashDebounce((searchTerm) => {
      onChange(searchTerm);
    }, 500),
    []
  );

  useEffect(() => {
    if (query) {
      search(query);
    }
  }, [query, search]);

  const handleInputChange = (e) => {
    setQuery(e);
  };

  return (
    <TextField
      placeholder={placeholder}
      className={clsx(classes.textField, className)}
      InputProps={{
        className: classes.inputField,
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon className={classes.searchIcon} />
          </InputAdornment>
        ),
      }}
      onChange={handleInputChange}
      {...props}
    />
  );
};

export default withStyles(styles)(SearchField);
